<template>
  <fragment>
    <hero-header page-name="mainNavBar.contact" hero-title="sendUsAMessage"/>
    <v-container fluid class="py-12">
      <v-container>
        <v-row justify="center">
          <v-card max-width="1140" style="overflow: hidden;" elevation="3">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" class="pa-0">
                  <!--v-col cols="12" md="5" class="px-10 py-12 primary-gradient-bg">
                    <v-row style="height: 100%;" align-content="center">
                      <v-col cols="12" class="py-4 text-center">
                        <span class="headline white--text">
                          {{ $t('ourEmail') }}:<br><a class="body-1 white--text">info@tmx.hu</a>
                        </span>
                      </v-col>
                    </v-row-->
                  <v-img :src="require(`../assets/tmx_contact_form_bg_6.jpg`)" class="align-stretch" cover
                         height="100%" aspect-ratio="1.333" position="center center">
                    <div class="d-flex flex-column justify-center" style="height: 100%;">
                      <v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp" class="mb-4">
                        mdi-email
                      </v-icon>
                      <div class="white--text text-center headline align-self-center">
                        {{ $t('ourEmail') }}:<br><a class="body-1 white--text">info@tmx.hu</a>
                      </div>
                      <!--v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp">
                        mdi-phone
                      </v-icon>
                      <div class="white--text text-center headline align-self-center">
                        {{ $t('ourPhoneNumber') }}:<br><a class="body-1 white--text">06-1/585-83-81</a>
                      </div-->
                    </div>
                  </v-img>
                </v-col>
                <v-col cols="12" md="7" class="px-10 py-12">
                  <v-form v-model="contactFormIsValid">
                    <v-row>
                      <v-col cols="12" class="py-4">
                        <span class="headline">
                          {{ $t('sendUsAMessage') }}
                        </span>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-select v-model="contactForm.topic"
                                  :items="$i18n.locale === 'hu-HU' ? selectFieldOptions.topics : $i18n.locale === 'en-EN' ? selectFieldOptions.topicsEN : selectFieldOptions.topicsDE"
                                  item-text="text"
                                  item-value="text"
                                  :label="$t('inputLabels.topic')"
                                  :rules="inputRules.generalRules"
                                  outlined
                                  dense
                                  clearable
                                  required>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-select v-model="contactForm.manufacturer"
                                  :items="$i18n.locale === 'hu-HU' ? selectFieldOptions.manufacturer : selectFieldOptions.manufacturerEN"
                                  item-text="text"
                                  item-value="text"
                                  :label="$t('inputLabels.manufacturer')"
                                  :rules="inputRules.generalRules"
                                  outlined
                                  dense
                                  required>
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.deviceId"
                                      :label="$t('inputLabels.imei')"
                                      dense
                                      outlined>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.fullName"
                                      :label="$t('inputLabels.name')"
                                      :rules="inputRules.generalRules"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.email"
                                      :label="$t('inputLabels.email')"
                                      :rules="inputRules.emailRules"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-text-field v-model="contactForm.subject"
                                      :label="$t('inputLabels.subject')"
                                      :rules="inputRules.generalRules"
                                      clearable
                                      clear-icon="mdi-close"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-textarea v-model="contactForm.message"
                                    :label="$t('inputLabels.message')"
                                    clearable
                                    dense
                                    clear-icon="mdi-close"
                                    outlined>
                        </v-textarea>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-checkbox
                            v-model="contactFormCheckbox"
                            :rules="inputRules.gdprRules"
                            required
                        >
                          <template slot="label">
                            <span v-show="$i18n.locale === 'hu-HU'" class="body-2">Az&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Adatvédelmi tájékoztatót</a>&nbsp;elolvastam és elfogadom.</span>
                            <span v-show="$i18n.locale === 'en-EN'" class="body-2">I have read and accept the&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Privacy Policy</a>.</span>
                            <span v-show="$i18n.locale === 'de-DE'" class="body-2">Ich habe das&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Datenschutz</a> gelesen und akzeptiere es.</span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <v-row justify="end">
                          <v-btn rounded large color="primary"
                                 :disabled="!contactFormIsValid" @click="sendContactForm" min-width="156">
                            {{ $t('button.send') }}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </v-container>
    <v-dialog v-model="loadingDialog.visible" width="90%" max-width="340" :persistent="true">
      <loading-dialog v-bind:loading-message="loadingDialog.message" />
    </v-dialog>
    <v-dialog v-model="responseDialog.visible" width="90%" max-width="340" :persistent="true">
      <response-dialog v-bind:response-object="responseDialog.response"
                       v-on:close-dialog="closeResponseDialog"/>
    </v-dialog>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import responseDialog from '../components/responseDialog.vue';
import loadingDialog from '../components/loadingDialog.vue';
import { SEND_SIMPLE_CONTACT_FORM } from '../store/actions.type';

export default {
  name: 'Contact',
  components: {
    heroHeader, responseDialog, loadingDialog,
  },
  data() {
    return {
      searchTopic: null,
      contactFormIsValid: false,
      contactFormCheckbox: false,
      loadingDialog: {
        visible: false,
        message: 'loadingMessages.INPROGRESS_CONTACT_FORM',
      },
      responseDialog: {
        visible: false,
        response: {
          error: false,
          data: [],
          message: 'successMessages.SUCCESS_CONTACT_FORM_2',
        },
      },
      contactForm: {
        topic: '',
        manufacturer: '',
        deviceId: '',
        fullName: '',
        email: '',
        subject: '',
        message: '',
      },
      selectFieldOptions: {
        topics: this.$store.state.generalStore.topics,
        topicsEN: this.$store.state.generalStore.topicsEN,
        topicsDE: this.$store.state.generalStore.topicsDE,
        manufacturer: this.$store.state.generalStore.manufacturer,
        manufacturerEN: this.$store.state.generalStore.manufacturerEN,
      },
      inputRules: {
        generalRules: [v => !!v || this.$t('inputMessages.requiredField')],
        emailRules: [
          v => /.+@.+\..+/.test(v) || this.$t('inputMessages.requiredField'),
        ],
        gdprRules: [
          v => !!v || this.$t('inputMessages.requiredPrivacy'),
        ],
      },
      publicPath: process.env.BASE_URL,
    };
  },
  methods: {
    async sendContactForm() {
      this.openLoadingDialog();
      const formToSend = this.contactForm;
      /* if (this.$i18n.locale === 'hu-HU') {
        formToSend.topic = this.$store.state.generalStore.topics[this.contactForm.topic - 1].text;
        formToSend.manufacturer = this.$store.state.generalStore.manufacturer[this.contactForm.manufacturer - 1].text;
      } else {
        formToSend.topic = this.$store.state.generalStore.topicsEN[this.contactForm.topic - 1].text;
        formToSend.manufacturer = this.$store.state.generalStore.manufacturerEN[this.contactForm.manufacturer - 1].text;
      } */
      try {
        const response = await this.$store.dispatch(SEND_SIMPLE_CONTACT_FORM, formToSend);
        if (response.error) {
          // this.setupResponseDialog(response);
        } else {
          // this.setupResponseDialog(response);
        }
        this.controlDialogs();
      } catch (err) {
        this.controlDialogs();
      }
    },
    openLoadingDialog() {
      this.loadingDialog.visible = true;
    },
    closeLoadingDialog() {
      this.loadingDialog.visible = false;
    },
    setupResponseDialog(resp) {
      this.responseDialog.response = resp;
    },
    openResponseDialog() {
      this.responseDialog.visible = true;
    },
    closeResponseDialog() {
      this.responseDialog.visible = false;
      // this.$router.push('/');
      window.location.reload();
    },
    controlDialogs() {
      setTimeout(this.closeLoadingDialog, 3000);
      setTimeout(this.openResponseDialog, 3200);
    },
  },
};
</script>

<style scoped>

</style>
